import { green, orange, red } from '@mui/material/colors';
import {
  ADMIN_CONST,
  ENTITY_CONST,
  FAMILY_CONST,
  ROOT_CONST,
  STUDENT_CONST,
  TEACHER_CONST,
  USER_CONST,
} from '../modules/auth/login/LoginReducer';

export const RED_COLOR = '#C84646';
export const VINO_COLOR = '#380C0C';
export const GREEN_COLOR = '#6BC158';
export const GREEN_DARK_COLOR = '#155916';
export const BLUE_COLOR = '#3278AF';
export const BLACK_COLOR = '#000000';
export const GRIS_COLOR = '#DDDEDE';
export const WHITE_COLOR = '#FCFCFA';
export const ORANGE_COLOR = '#F0AA00';
export const PURPLE_COLOR = '#6A2C90';

export const notaColor = (nota) => {
  return nota > 15
    ? GREEN_COLOR
    : nota <= 15 && nota > 9
    ? ORANGE_COLOR
    : RED_COLOR;
};
export const notaHoverColor = (nota) => {
  return nota
    ? nota > 15
      ? green[900]
      : nota <= 15 && nota > 9
      ? orange[700]
      : red[900]
    : BLACK_COLOR;
};
export const rolColor = ({ rol = USER_CONST, admin = false }) => {
  if (rol === TEACHER_CONST && admin) return GREEN_DARK_COLOR;

  if (rol === ROOT_CONST) return PURPLE_COLOR;
  if (rol === ADMIN_CONST) return RED_COLOR;
  if (rol === ENTITY_CONST) return VINO_COLOR;
  if (rol === TEACHER_CONST) return GREEN_COLOR;
  if (rol === FAMILY_CONST) return ORANGE_COLOR;
  if (rol === STUDENT_CONST) return BLUE_COLOR;
  if (rol === USER_CONST) return ORANGE_COLOR;
};
